import type { LucideIcon } from 'lucide-react'
import { cn } from '../../lib/utils'

/** Up to three overlapping photos, the first on top, or the type icon when there are none. */
export function ThumbStack({
  srcs,
  icon: Icon,
  round,
  size = 'sm',
}: {
  srcs: (string | undefined)[]
  icon: LucideIcon
  round?: boolean
  size?: 'sm' | 'md'
}) {
  const dim = size === 'md' ? 'size-10' : 'size-8'
  const shown = srcs.filter((s): s is string => !!s).slice(0, 3)
  const shape = round ? 'rounded-full' : 'rounded-md'
  if (shown.length === 0) {
    return (
      <div className={cn('flex shrink-0 items-center justify-center bg-muted text-primary', dim, shape)}>
        <Icon className="size-4" />
      </div>
    )
  }
  return (
    <div className="flex -space-x-3">
      {shown.map((src, i) => (
        <img
          key={src}
          src={src}
          alt=""
          loading="lazy"
          style={{ zIndex: shown.length - i }}
          className={cn('relative shrink-0 object-cover ring-2 ring-card', dim, shape)}
        />
      ))}
    </div>
  )
}
